// extracted by mini-css-extract-plugin
export default {"editIcon":"Users_editIcon__NYQ7p"};